<template>
  <WdsSelect
    v-model="selectedAgencies"
    multi-select
    searchable
    class="tw-min-w-[150px]"
    data-test="staffing-agencies-filter"
    :label="meta.filter.quickFilter ? '' : $t('Staffing agency')"
    :list="agencyOptions"
    :placeholder="$t('Select staffing agencies to filter by')"
    :max-labels-visible="meta.filter.quickFilter ? 1 : 5"
    can-deselect
    labels-primary
  />
</template>

<script setup lang="ts">
import { computed, ModelRef } from 'vue'
import { useQuery } from '@vue/apollo-composable'
import { WdsSelect } from '@worksome/wds-components'
import { graphql } from '@/gql'
import { $t } from '@/composables/translation'
import { FilterMetaDataProp } from '@/components/GraphqlDataTable/filters/types'

type AgencyOption = { label: string; value: string }

const selectedAgencies: ModelRef<AgencyOption[]> = defineModel({
  default: () => [],
})

defineProps<{ meta: FilterMetaDataProp }>()

const STAFFING_AGENCY_OPTIONS = graphql(`
  query StaffingAgenciesFilterOptions {
    companyRecruiters(first: 100) {
      data {
        id
        recruiter {
          id
          name
        }
      }
    }
  }
`)

const { result } = useQuery(STAFFING_AGENCY_OPTIONS, {}, { clientId: 'publicApi' })

const agencyOptions = computed<AgencyOption[]>(
  () =>
    result.value?.companyRecruiters?.data.map((relation) => ({
      label: relation.recruiter.name,
      value: relation.recruiter.id,
    })) ?? [],
)
</script>
